// @flow
import { connect } from 'react-redux';

import * as selectors from '../../reducers';
import ErrorList from '../ErrorList';


export default connect(
  (state) => {
    const { data } = selectors.getLoginError(state);
    return (
      data && data.non_field_errors
        ? {
          errors: data.non_field_errors.map(title => ({ title })),
        }
        : {
          errors: [],
        }
    );
  },
  undefined,
)(ErrorList);



// WEBPACK FOOTER //
// ./src/scripts/components/LoginError/index.jsx